// import "./FeaturedMenu.css";
// import { Link } from "react-router-dom";
// export default function FeaturedMenu() {
//   const items = [
//     // -------------------------
//     // ⭐ NEW ITEMS BELOW
//     // -------------------------

//     {
//       title: "Nosh & Nector Burger",
//       img: "/assets/images/foodfinal12.png",
//       oldPrice: "£ 19.99",
//       newPrice: "18 $"
//     },
//     {
//       title: "Classic Poutine",
//       img: "/assets/images/foodfinal22.png",
//       oldPrice: "£ 30.00",
//       newPrice: "12.50 $"
//     },
//     {
//       title: "Fisherman Stew",
//       img: "/assets/images/foodfinal32.png",
//       oldPrice: "£ 26.50",
//       newPrice: "26 $"
//     },
//     {
//       title: "SeaFood Chowder",
//       img: "/assets/images/foodfinal42.png",
//       oldPrice: "£ 19.99",
//       newPrice: "16 $"
//     },
//     {
//       title: "Chicken Wings",
//       img: "/assets/images/foodfinal52.png",
//       oldPrice: "£ 18.00",
//       newPrice: "1 Pound 17 $"
//     },
//     {
//       title: "Mussels",
//       img: "/assets/images/foodfinal62.png",
//       oldPrice: "£ 22.50",
//       newPrice: "1 Pound 17 $"
//     },
//     {
//       title: "Ash edmonds",
//       img: "/assets/images/foodfinal72.png",
//       oldPrice: "£ 20.00",
//       newPrice: "12 $"
//     },
//     {
//       title: "Blue Raspberry Lemonade ",
//       img: "/assets/images/foodfinal82.png",
//       oldPrice: "£ 12.00",
//       newPrice: "6 $"
//     }
//   ];


//   return (
//     <section className="fm-section">
//       <p className="fm-toptext">FEATURED MENU</p>
//       <h2 className="fm-title">Special proposals</h2>
//       <p className="fm-subtitle">
//         Porro eveniet, autem ipsam corrupti consectetur cum.<br />
//         Repudiandae dignissimos fugiat sit nam.
//       </p>

//       <div className="cocktail-grid">
//         {items.map((item, index) => (
//           <div className="cocktail-card" key={index}>
//             <img src={item.img} alt={item.title} className="cocktail-img" />

//             <h3 className="cocktail-title">{item.title}</h3>

//             <div className="cocktail-rating">
//               ★★★★★
//             </div>

//             <p className="cocktail-price">{item.newPrice}</p>
//           </div>
//         ))}
//       </div>

//       <Link to="/menu">
//         <button className="hero-btn-outline">OPEN MENU</button>
//       </Link>


//     </section>
//   );
// }

import "./FeaturedMenu.css";
import { Link } from "react-router-dom";

export default function FeaturedMenu() {
  const items = [
    // {
    //   title: "Nosh & Nector Burger",
    //   img: "/assets/images/foodfinal12.png",
    //   oldPrice: "£ 19.99",
    //   newPrice: "18 $"
    // },
    //  {
    //   title: "Classic Poutine",
    //   img: "/assets/images/foodfinal22.png",
    //   oldPrice: "£ 30.00",
    //   newPrice: "12.50 $"
    // },
    {
      title: "Bistecca (Steak)",
      img: "/assets/menu/bistecca1.png",
      newPrice: "$38"
    },
    {
      title: "Beef Pappardelle",
      img: "/assets/menu/beefpappardelle.png",
      newPrice: "$26"
    },
    {
      title: "Lamb Shank",
      img: "/assets/menu/lamb_shank.png",
      newPrice: "$32"
    },
    {
      title: "Seafood Pescatore",
      img: "/assets/menu/seafoodpescatore.png",
      newPrice: "$29"
    },
    {
      title: "Chicken Cacciatore",
      img: "/assets/menu/chicken_cacciatore.png",
      newPrice: "$24"
    },
    {
      title: "Atlantic Salmon",
      img: "/assets/menu/atlantic_salmon.png",
      newPrice: "$28"
    },
    {
      title: "Mapla Bourbon Smash",
      img: "/assets/menu/maple_bourbon_smash.png",
      newPrice: "$15"
    },
    {
      title: "Cosmopolitan",
      img: "/assets/menu/cosmopolitan.png",
      newPrice: "$14"
    }
  ];

  return (
    <section className="fm-section">
      <p className="fm-toptext">FEATURED MENU</p>

      <h2 className="fm-title">OUR SIGNATURES</h2>

      <p className="fm-subtitle">
        Homemade favourites, loved by our guests.
      </p>

      <div className="cocktail-grid">
        {items.map((item, index) => (
          <div className="cocktail-card" key={index}>
            <img
              src={item.img}
              alt={item.title}
              className="cocktail-img"
            />

            <h3 className="cocktail-title">{item.title}</h3>

            <div className="cocktail-rating">★★★★★</div>

            <p className="cocktail-price">{item.newPrice}</p>
          </div>
        ))}
      </div>

      <Link to="/menu">
        <button className="hero-btn-outline">OPEN MENU</button>
      </Link>
    </section>
  );
}
